import React from 'react';
import SMOSpaceEditBaseFragment from './SMOSpaceEditBaseFragment';

class SMOSpaceEditBusinessHourFragment extends SMOSpaceEditBaseFragment {
  
  constructor(props) {
    super(props);
    this.state = {
      space: this.props.space,
      isCurrent : this.isCurrent(this.props),
      errors: this.props.errors,
      extraBusinessHours: this.props.space.extra_business_hours
    };
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    if (this.state.isCurrent) this.sizeToFit();
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({
      isCurrent : this.isCurrent(nextProps),
      space : nextProps.space,
    });
  }
  
  render() {
    return (
      <div ref="fragment" style={this.fragmentStyle()}>
        <div ref="mainTableFooter" className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
          <a href="#" className="button button-green maincol-buttonarea__button" onClick={this.didSelectNextFragment.bind(this)}>次へ</a>
        </div>

      </div>
    );
  }
}

SMOSpaceEditBusinessHourFragment.defaultProps = {
  errors: [],
};
export default SMOSpaceEditBusinessHourFragment;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/fragments/SMOSpaceEditBusinessHourFragment.jsx